import { render } from "./StaffLearningManagementPage.vue?vue&type=template&id=7c3e9d65"
import script from "./StaffLearningManagementPage.vue?vue&type=script&lang=js"
export * from "./StaffLearningManagementPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__